// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PendingIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PendingIcon" ref={forwardedRef} {...props}>
      <path d="M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
      <path d="M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0" />
    </SvgIcon>
  );
});

/**
 * Use for Live Debugging
 * @public
 */
export const PendingIcon = /* @__PURE__ */ Object.assign(PendingIconComponent, {
  displayName: 'PendingIcon',
});
